// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import FastClick from "fastclick";
import App from "./App";
import VueLazyload from "vue-lazyload";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import Vuelidate from "vuelidate";
import loadingImg from "../static/images/common/default-placeholder.png";
import router from "./router/index";
import store from "./store/index";
import { ConfirmPlugin, AlertPlugin } from "./plugins/confirm/index";
import { ToastPlugin, LoadingPlugin } from "./plugins/toast/index";
import { CURRENT_PUBLISHER_ID } from "./store/mutation-types";
import VueScroller from "vue-scroller";
import vuexI18n from "vuex-i18n";
import arLang from "./lang/ar";
import deDELang from "./lang/de-DE";
import enLang from "./lang/en";
import es419Lang from "./lang/es-419";
import frFRLang from "./lang/fr-FR";
import idLang from "./lang/id";
import itITLang from "./lang/it-IT";
import jaJPLang from "./lang/ja-JP";
import koKRLang from "./lang/ko-KR";
import msLang from "./lang/ms";
import ptBRLang from "./lang/pt-BR";
import ruRULang from "./lang/ru-RU";
import thLang from "./lang/th";
import zhTWLang from "./lang/zh-TW";
import zhLang from "./lang/zh";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
let app;
console.log("version:2019.7.2");
// 设置日志监控
try {
  Vue.use(VueAwesomeSwiper /* { default global options } */);
  Vue.use(ConfirmPlugin);
  Vue.use(AlertPlugin);
  Vue.use(ToastPlugin);
  Vue.use(LoadingPlugin);
  Vue.use(Vuelidate);
  Vue.use(VueScroller);
  Vue.use(vuexI18n.plugin, store);
  Raven.config("https://e78b384bda774bfe8a3bfaa295f14497@sentry.io/1205730")
    .addPlugin(RavenVue, Vue)
    .install();
  Raven.setTagsContext({ environment: process.env.NODE_ENV });
  // 设置点击延迟插件
  FastClick.attach(document.body);
  Vue.config.productionTip = false;
  // 图片懒加载
  Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: loadingImg,
    loading: loadingImg,
    attempt: 1,
  });
  Vue.i18n.add("en", enLang); // 英文语言包
  Vue.i18n.add("ar", arLang); // 阿拉伯语言包
  Vue.i18n.add("de", deDELang); // 德国语言包 de-DE
  Vue.i18n.add("es", es419Lang); // 西班牙语 es-ES
  Vue.i18n.add("fr", frFRLang); // 法国 fr-FR
  Vue.i18n.add("id", idLang); // 印尼 in-ID
  Vue.i18n.add("it", itITLang); // 意大利 it-IT
  Vue.i18n.add("ja", jaJPLang); // 日本 ja-JP
  Vue.i18n.add("ko", koKRLang); // 韩国 ko-KR
  Vue.i18n.add("ms", msLang); // 马来 ms
  Vue.i18n.add("pt", ptBRLang); // 葡萄牙 -巴西 pt-BR
  Vue.i18n.add("ru", ruRULang); // 俄国accept language ru-RU
  Vue.i18n.add("th", thLang); // 泰国 th-TH
  Vue.i18n.add("zh-Hans", zhLang); // 简体中文 zh-CN
  Vue.i18n.add("zh-Hant", zhTWLang); // 中文繁体(中华人民共和国)zh-TW
  // 此处强制触发vuex
  if (store) {
    if (!store.getters[CURRENT_PUBLISHER_ID]) {
      store.commit(CURRENT_PUBLISHER_ID, null);
    }
  } else {
    alert("store not found");
  }
  /* eslint-disable no-new */
  app = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app-box");
} catch (e) {
  console.error(e);
}

// 全局初始化 stripe instance
// stripe 脚本在 head 中阻塞加载
Vue.prototype.$stripe = window.Stripe(process.env.STRIPE_PUBLISHABLE_KEY);

export default app;



// WEBPACK FOOTER //
// ./src/main.js